var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-lead-snp-support" },
    [
      _c("h5", { staticClass: "wkb-lead-snp-title" }, [_vm._v("Lead SNPs")]),
      _vm.snps.length
        ? [
            _c(
              "div",
              { staticClass: "wkb-lead-snp-list" },
              _vm._l(_vm.snps, function (snp, index) {
                return _c(
                  "div",
                  {
                    key: `${snp.location_hg19}-${index}`,
                    staticClass: "wkb-lead-snp-row",
                  },
                  [
                    _c("p", [
                      _c("strong", [_vm._v("Location (hg19):")]),
                      _c("span", { staticClass: "wkb-lead-snp-location" }, [
                        _vm._v(_vm._s(snp.location_hg19 || "NA")),
                      ]),
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("P-value:")]),
                      _vm._v(" " + _vm._s(_vm.formatPValue(snp.p_value)) + " "),
                    ]),
                    _c("p", [
                      _c("strong", [_vm._v("Effector probability:")]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatProbability(snp.effector_probability)
                          ) +
                          " "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm.total > _vm.snps.length
              ? _c("small", [
                  _vm._v(
                    " Showing " +
                      _vm._s(_vm.snps.length) +
                      " of " +
                      _vm._s(_vm.total) +
                      " SNPs. "
                  ),
                ])
              : _vm._e(),
          ]
        : _c("p", [_c("strong", [_vm._v("Location (hg19):")]), _vm._v(" NA")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }